module.exports = __webpack_public_path__ + "img/popup_btn_received.89636b95.png";